import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
import SPGVariables from '../../../utilities/spg-variables';

import { cn } from '../../../helpers';

const spgVariables = SPGVariables();

const useStyles = makeStyles(() => ({
    root: {
        border: 'none'
    },
    expansionPanels: {
        borderBottom: '2px solid #000',
        paddingRight: '2px',
        alignItems: 'flex-start'
    },
    icon: {
        color: 'black'
    },
    expandIcon: {
        padding: '0',
        position: 'relative'
    }
}));

export default function SimpleExpansionPanel(props: AccordionProps) {
    const {
        children,
        title,
        className,
        borderBottomTitle = false,
        expandIcon,
        closeIcon,
        isInitiallyExpanded = false,
        onChange,
        disabled = false,
        expandable = true
    } = props;
    const classes = useStyles();
    const linkListClass = borderBottomTitle ? 'accordion--link-list' : '';
    const headingClass = borderBottomTitle ? 'subheading' : '';
    const ExpandIcon = expandIcon || ExpandMoreIcon;
    const CloseIcon = closeIcon || ExpandMoreIcon;
    const [expanded, setExpanded] = React.useState<boolean>(!!spgVariables.IS_CRAWLER_REQUEST || isInitiallyExpanded);

    const getChangedValue = () => {
        if (onChange) {
            onChange(!expanded);
        }
        setExpanded(expandable && !expanded);
        return !expanded;
    };

    return (
        <ExpansionPanel
            disabled={disabled}
            onChange={getChangedValue}
            className={cn('accordion', className, linkListClass, classes.root)}
            expanded={expanded}
        >
            <ExpansionPanelSummary
                className={borderBottomTitle ? classes.expansionPanels : ''}
                expandIcon={
                    expandable &&
                    (expanded ? (
                        <CloseIcon className={cn(classes.icon, classes.expandIcon)} />
                    ) : (
                        <ExpandIcon className={cn(classes.icon, classes.expandIcon)} />
                    ))
                }
            >
                <h5 className={cn('accordion__heading', headingClass)}>{title}</h5>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails>{children}</ExpansionPanelDetails>
        </ExpansionPanel>
    );
}
